import { render, staticRenderFns } from "./ChartFreq.vue?vue&type=template&id=36cbaf1d&scoped=true"
import script from "./ChartFreq.vue?vue&type=script&lang=js"
export * from "./ChartFreq.vue?vue&type=script&lang=js"
import style0 from "./ChartFreq.vue?vue&type=style&index=0&id=36cbaf1d&prod&scoped=true&lang=css"
import style1 from "./ChartFreq.vue?vue&type=style&index=1&id=36cbaf1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbaf1d",
  null
  
)

export default component.exports